import script from "./ColorManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorManagement.vue?vue&type=script&setup=true&lang=js"

import "./ColorManagement.vue?vue&type=style&index=0&id=d432af80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d432af80"]])

export default __exports__